import script from "./TableBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableBlock.vue?vue&type=script&setup=true&lang=ts"

import "./TableBlock.vue?vue&type=style&index=0&id=af122f38&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af122f38"]])

export default __exports__